module.exports = __webpack_public_path__ + "static/under-tree-046e2a1a73247668aa0368b1c1a9bb04.jpg";